import { render, staticRenderFns } from "./CoozzyDropdown.vue?vue&type=template&id=70fb45a7&scoped=true"
import script from "./CoozzyDropdown.vue?vue&type=script&lang=js"
export * from "./CoozzyDropdown.vue?vue&type=script&lang=js"
import style0 from "./CoozzyDropdown.vue?vue&type=style&index=0&id=70fb45a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb45a7",
  null
  
)

export default component.exports